'use strict';

var $ = require('jquery');

function Accordion(config) {
	this.item = 'accordion';
	this.$item = $('.' + this.item);
	this.config = $.extend({}, {
		scope: 'body'
	}, config);
}

Accordion.prototype.activate = function () {
	if (!this.$item.length || !$(this.config.scope).length) {
		return;
	}
	this.attachHandlers();
};

Accordion.prototype.attachHandlers = function () {
	var that = this;
	$('.accordion__heading').on('click', function(event) {
		event.preventDefault();

		var accordionElement = $(this).closest(that.$item);
		that.toggleAccordion(this, accordionElement);
	});
};

Accordion.prototype.toggleAccordion = function (item, accordion) {
	if ($(accordion).hasClass(this.item + '--active')) {
		$(accordion).removeClass(this.item + '--active');
	} else {
		$(accordion).addClass(this.item + '--active');
	}
};

module.exports = Accordion;
